
import { computed, onBeforeMount, ref, createVNode, watch } from 'vue'
import { getInfoPermissionFromUser } from './commonUtils'
import * as service from '../service'
import { debounce } from '@/utils/common'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'
import Empty from '@/components/common/Empty.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  components: {
    // SearchOutlined,
    SelectBookModal
  },
  setup (props, { emit }) {
    // 弹窗可见性
    const visibleValue = computed(() => props.visible)
    // 关闭事件
    const handleCancel = () => {
      emit('onCancel')
    }

    // tab列的key值
    const tabKey = getInfoPermissionFromUser()
    // computed属性的tabkey值的集合
    const tabSet = computed(() => new Set(tabKey))

    const currentTabKey = ref(tabKey[0] || null)

    const formData = ref({
      name: undefined,
      author_name: undefined,
      book_id: undefined,
      book_section_id: undefined
    })
    // 监听 formData.name
    watch(() => formData.value.name, () => {
      handleSearchBtnClick()
    })
    const bookModalVisible = ref(false)
    const bookModalRef = ref()
    const bookShowName = ref('教材名称-章节目录')

    const handleBookSelectOk = (value) => {
      /**
       * 1。value 有值
       *  1. 选中教材 课时 book_id book_section_id=值 showmname=value.labels.join('-')
       *  2. 选中教材 book_id =值 book_section_id=undefined  showmname=value.labels[0]
       *  3. 选中课时   不存在
       * 2. value 没值
       *  1，没有选中value教材 课时  book_id =undefined book_section_id=undefined showmname=初始值的显示值
       */
      if (value.labels === undefined) {
        handleResetOk()
        bookModalVisible.value = false
      } else {
        bookShowName.value = value.labels.join('-')
        formData.value.book_id = value.values[0]
        formData.value.book_section_id = value.values[1]
        bookModalVisible.value = false
        currentPage = 1
        handleSearchBtnClick()
      }
    }

    const handleShowBookModal = () => {
      bookModalVisible.value = true
    }

    const tagOpts = ref([])

    const getTagSearch = debounce(async (value) => {
      let SearchFunc = null
      if (currentTabKey.value === 'official') {
        SearchFunc = service.getOfficialTag
      }
      // else if (currentTabKey.value === 'personal') {
      //   SearchFunc = service.getTeacherTags
      // }
      if (SearchFunc !== null) {
        const tagList = await SearchFunc({ keyword: value, current: 1, per_page: 20 })
        tagOpts.value = tagList.items.map(item => { return { label: item.tag, value: item.tag } })
      }
    })

    // 列表数据
    const dataList = ref([])
    const cloumns = [
      {
        title: '题目名称',
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
        width: 80
      },
      {
        title: '题目作者',
        dataIndex: 'author_name',
        key: 'author_name',
        width: 80,
        ellipsis: true
      },
      {
        title: '题目数量',
        dataIndex: 'extend_data.question_num',
        key: 'extend_data.question_num',
        ellipsis: true,
        width: 80
      },
      {
        title: '关联教材',
        dataIndex: 'book.name',
        key: 'book.name',
        ellipsis: true,
        width: 80
      },
      {
        title: '教材出版社',
        dataIndex: 'book.press_version.name',
        ellipsis: true,
        width: 80
      },
      {
        title: '关联教材章节',
        dataIndex: 'section.name',
        key: 'book.name',
        ellipsis: true,
        width: 80
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 80,
        slots: { customRender: 'actions' }
      }
    ]
    let currentPage = 1
    const handlePageChange = (page) => {
      currentPage = page
      handleSearch()
    }
    // 第一次进入页面
    const isFirst = ref(false)

    // 检索为空提示
    const locale = {
      emptyText: createVNode(Empty, { value: isFirst.value })
    }

    watch(isFirst, (newValue) => {
      if (newValue === true) {
        locale.emptyText = createVNode(Empty, { value: isFirst.value })
      }
    })

    const paginations = ref({ current: currentPage, pageSize: 10, onChange: handlePageChange })
    const loading = ref(false)

    const queryOfficialList = async (params) => {
      try {
        loading.value = true
        const data = await service.getOfficialQGroup({
          ...params,
          type: 'qgroup',
          status: 1,
          per_page: paginations.value.pageSize,
          page: currentPage
        })
        paginations.value = { ...paginations.value, ...data.meta, pageSize: +data.meta.per_page, current: data.meta.current_page }
        dataList.value = data.items
        loading.value = false
      } catch (error) {
        loading.value = false
        console.error(error)
        throw error
      }
    }

    const handleSearch = async () => {
      let searchFunc = null
      if (currentTabKey.value === 'official') {
        searchFunc = queryOfficialList
      }

      if (searchFunc !== null) {
        const params = formData.value
        await searchFunc(params)
      }
    }

    const handleSearchBtnClick = async () => {
      currentPage = 1
      await handleSearch()
    }

    const handleResetForm = () => {
      formData.value = {
        name: undefined,
        tag: [],
        book_id: undefined,
        book_section_id: undefined
      }
      getTagSearch('')
      currentPage = 1
      bookShowName.value = '教材名称-章节目录'
      bookModalRef.value.handleReset()
      handleSearch()
    }
    // 当未选中书籍时候官方歌曲表单恢复初始值
    const handleResetOk = () => {
      formData.value = {
        name: undefined,
        tag: [],
        book_id: undefined,
        book_section_id: undefined
      }
      getTagSearch('')
      currentPage = 1
      bookShowName.value = '教材名称-章节目录'
      handleSearch()
    }
    onBeforeMount(() => {
      getTagSearch('')
      handleSearch().then(() => {
        isFirst.value = true
      })
    })

    const handleAddQGroup = (record) => {
      emit('onOk', {
        sid: record.id,
        source: record.source,
        meta: {
          questionGroupName: record?.name,
          ...record.extend_data
        }
      })
      emit('onCancel')
    }

    return {
      visibleValue,
      currentTabKey,
      tabSet,
      dataList,
      cloumns,
      paginations,
      loading,
      formData,
      tagOpts,
      getTagSearch,
      bookShowName,
      bookModalRef,
      bookModalVisible,
      handleSearchBtnClick,
      handleBookSelectOk,
      handleShowBookModal,
      handleSearch,
      handleResetForm,
      handleCancel,
      queryOfficialList,
      handleAddQGroup,
      locale
    }
  }

}
